import { gql } from '@apollo/client'

export const VALIDATE_TEST_LOCATION_ADDRESS = gql`
  query ValidateTestLocationAddress($Address: AddressInput!) {
    validateTestLocation(Address: $Address) {
      id
    }
  }
`
